import {useEffect, useRef} from 'react';
import {type UseFormSetValue} from 'react-hook-form';
import type {SelectOptionType, DocumentChoice} from '@guestapp/sdk';
import {
  useIVStore,
  getDocumentType,
  getDocumentNationality,
} from 'store/identityVerification';
import {useFetchLocations} from 'hooks';
import {FORM_NAMES} from 'utils/guestForm';
import {FormTypes} from './types';

type InitDocumentTypeProps = {
  nationality?: SelectOptionType;
  options: SelectOptionType<DocumentChoice>[];
  setValue: UseFormSetValue<FormTypes>;
};
export const useInitDocumentType = ({
  options,
  setValue,
  nationality,
}: InitDocumentTypeProps) => {
  const isNotCheckedRef = useRef<boolean>(true);
  const documentType = useIVStore(getDocumentType);

  useEffect(() => {
    if (isNotCheckedRef.current && nationality && options.length) {
      isNotCheckedRef.current = false;
      const documentTypeOption = options.find(
        option => option.value === documentType?.value,
      );

      if (documentTypeOption) {
        setValue(FORM_NAMES.document_type, documentTypeOption);
      }
    }
  }, [documentType, nationality, options, setValue]);
};

type InitNationalityProps = {
  setValue: UseFormSetValue<FormTypes>;
};
export const useInitNationality = ({setValue}: InitNationalityProps) => {
  const isNotCheckedRef = useRef<boolean>(true);
  const {isLoadingLocations, locationsAsOptions} = useFetchLocations();
  const nationality = useIVStore(getDocumentNationality);

  useEffect(() => {
    if (isNotCheckedRef.current && !isLoadingLocations) {
      isNotCheckedRef.current = false;
      const locationOption = locationsAsOptions.find(
        location => location.value === nationality,
      );

      if (locationOption) {
        setValue(FORM_NAMES.nationality, locationOption);
      }
    }
  }, [isLoadingLocations, locationsAsOptions, nationality, setValue]);
};
